import { OTPInputContext } from 'input-otp';
import { useContext, ComponentPropsWithoutRef, Ref } from 'react';

import { styles } from './InputOTPSlot.styles';

export type InputOTPSlotProps = {
  index: number;
  ref?: Ref<HTMLDivElement>;
} & ComponentPropsWithoutRef<'div'>;

export function InputOTPSlot({
  className,
  index,
  ref,
  ...props
}: InputOTPSlotProps) {
  const inputOTPContext = useContext(OTPInputContext);
  const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index];

  const slots = styles({ isActive });

  return (
    <div
      ref={ref}
      className={slots.base({ className })}
      {...props}
    >
      {char}
      {hasFakeCaret && (
        <div className={slots.fakeCaretWrapper()}>
          <div className={slots.fakeCaret()} />
        </div>
      )}
    </div>
  );
}

InputOTPSlot.displayName = 'InputOTPSlot';
